import { render } from "./NewConfigurationStepSelectType.vue?vue&type=template&id=532c2e1a&scoped=true"
import script from "./NewConfigurationStepSelectType.vue?vue&type=script&lang=js"
export * from "./NewConfigurationStepSelectType.vue?vue&type=script&lang=js"

import "./NewConfigurationStepSelectType.vue?vue&type=style&index=0&id=532c2e1a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532c2e1a"]])

export default __exports__